export const config = {
  logoSrc: "/willovate-mark.png",
  signupBgImage: "/image.png",
  signupTitle: "What Next??",
  
  // API Configuration
  apiBaseUrl: process.env.REACT_APP_API_URL || "https://willovate.in/payment/api",
  paymentUrl: process.env.REACT_APP_PAYMENT_URL || "https://willovate.in/payment",
  
  // Currency Configuration
  currency: "INR",
  currencySymbol: "₹",
  
  // Company Information (Required for PhonePe approval)
  company: {
    name: "Willovate",
    legalName: "Willovate Private Limited",
    address: "Nagpur, Maharashtra",
    phone: "+91 93223 46482",
    email: "admin@willovate.in",
    website: "https://www.willovate.in"
  },
  
  // Pricing Plans (in INR)
  pricing: {
    iotDevelopment: {
      name: "IoT Development Program",
      duration: "12 months",
      price: 10000,
      originalPrice: 12000,
      currency: "INR",
      features: [
        "Arduino & Raspberry Pi",
        "Sensor Integration",
        "Cloud Connectivity",
        "Smart Home Projects",
        "Industrial IoT",
        "Job-Ready Training"
      ]
    },
    webDevDSA: {
      name: "Web Development + DSA Program",
      duration: "12 months",
      price: 10000,
      originalPrice: 12000,
      currency: "INR",
      features: [
        "MERN Stack Development",
        "Data Structures & Algorithms",
        "LeetCode Problem Solving",
        "System Design",
        "Interview Preparation",
        "Job Placement Support"
      ]
    },
    aiMachineLearning: {
      name: "AI & Machine Learning Program",
      duration: "12 months",
      price: 20000,
      originalPrice: 25000,
      currency: "INR",
      features: [
        "GenAI & LLMs",
        "Deep Learning",
        "Machine Learning Models",
        "MLOps & Deployment",
        "AI Projects Portfolio",
        "Job Guarantee | ₹5-10 LPA"
      ]
    }
  },
  
  footerLinks: [
    { label: "Home", link: "/" },
    { label: "About Us", link: "/about" },
    { label: "Contact Us", link: "/contact" },
  ],
  socialLinks: [
    { platform: "Instagram", url: "https://www.instagram.com/willovate_/" },
    { platform: "YouTube", url: "https://www.youtube.com/@Willovate" },
    { platform: "LinkedIn", url: "https://www.linkedin.com/company/willovate/" },
  ],
};
